import apiFetch from '../services/apiFetch';

// Course endpoints. fetchAllCourses walks the paginated /api/courses.
export default async function fetchAllCourses(token, perPage = 100) {
    const courses = [];
    let page = 1;
    while (true) {
        const res = await apiFetch(`/api/courses?page=${page}&per_page=${perPage}`, token, { method: 'GET' });
        if (!res.ok) throw new Error(`Loading courses failed (${res.status})`);
        const data = await res.json();
        courses.push(...(data.items || []));
        const totalPages = data?._meta?.total_pages || 1;
        if (page >= totalPages) break;
        page += 1;
    }
    return courses;
}

// Every course category (id, name, icon_url); the app's 8 + curated rails.
export async function fetchCategories(token) {
    const res = await apiFetch('/api/courses/categories?per_page=200', token, { method: 'GET' });
    if (!res.ok) throw new Error(`Loading categories failed (${res.status})`);
    const data = await res.json();
    return (data.items || []).sort((a, b) => a.name.localeCompare(b.name));
}
